export default __webpack_public_path__ + "static/media/home.5425da10.jpg";